import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles = {
  errorMessage: {
    display: 'grid',
    gridTemplateColumns: '18px auto', // Icon and text
    alignItems: 'center',
    gap: '15px', // Fal Icon Space
    color: '#D03A2C',
    fontSize: '14px',
    fontWeight: 500,
    marginTop: '-15px',
    marginBottom: '10px',
  },
  errorIcon: {
    marginLeft: '15px',
    width: '15px',
    height: '15px',
  },
  errorText: {
    lineHeight: '1.4',
  },
}

const ErrorMessage = ({ message }) => (
  <div style={styles.errorMessage}>
    <FontAwesomeIcon icon={['fal', 'circle-exclamation']} style={styles.errorIcon} />
    <span style={styles.errorText}>{message}</span>
  </div>
)

export default ErrorMessage
